// extracted by mini-css-extract-plugin
export default {"center":"Spinner_center__zXnpz","spinner":"Spinner_spinner__xmJ3X","spinner-aib1d7":"Spinner_spinner-aib1d7__gIGiX"};